
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import YakgwaPage from "../pages/product/yakgwa/page";
import YugwaPage from "../pages/product/yugwa/page";
import GiftSetPage from "../pages/product/gift-set/page";
import GangjeongPage from "../pages/product/gangjeong/page";
import DasikPage from "../pages/product/dasik/page";
import JeonggwaPage from "../pages/product/jeonggwa/page";
import CustomOrderPage from "../pages/custom-order/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/product/yakgwa",
    element: <YakgwaPage />,
  },
  {
    path: "/product/yugwa",
    element: <YugwaPage />,
  },
  {
    path: "/product/gift-set",
    element: <GiftSetPage />,
  },
  {
    path: "/product/gangjeong",
    element: <GangjeongPage />,
  },
  {
    path: "/product/dasik",
    element: <DasikPage />,
  },
  {
    path: "/product/jeonggwa",
    element: <JeonggwaPage />,
  },
  {
    path: "/custom-order",
    element: <CustomOrderPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
